/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.1
 * @since 1.14.1
 */

import { AccessComponentKeyEnum } from '../../../modules/role/constants/guard/guardConstants';
import { guardComponentType } from '../../../modules/role/reducer/guardReducer';
import { ExternalRoutePath } from '../../../routes/constants/externalRoutes';
import { CLIENT_ID, RoutePath } from '../../../routes/constants/routesConstants';
import { stringFormat } from '../../../utils/stringFormat';

export const getWizardBillsDocUrl = (guardTypes: guardComponentType, unpaid: boolean, id?: string) => {
    if (isWizardBillsDocExternalUrl(guardTypes)) {
        return unpaid
            ? id ? stringFormat(ExternalRoutePath.billsDocsAccountUnpaid, id) : ExternalRoutePath.billsDocsUnpaid
            : id ? stringFormat(ExternalRoutePath.billsDocsAccount, id) : ExternalRoutePath.billsDocs;
    }
    return unpaid
        ? id ? RoutePath.wizardBillsDocsUnpaidAccount.replace(CLIENT_ID, id) : RoutePath.wizardBillsDocsUnpaid
        : id ? RoutePath.wizardBillsDocsAccount.replace(CLIENT_ID, id) : RoutePath.wizardBillsDocs;
};

export const isWizardBillsDocExternalUrl = (guardTypes: guardComponentType) =>
    !guardTypes[AccessComponentKeyEnum.PageWizardBillsDocs];
